import React from 'react';
import {Spinner} from 'react-bootstrap';

export const showSpinDiag =(showSpin,data)=>{
if(showSpin){
  return <span><Spinner animation="border" variant="danger" /> {data} Please wait...</span>;
}
}
